module.exports = __webpack_public_path__ + "fonts/Prompt-ExtraLightItalic.7780f529.ttf";